import { app } from "/src/firebase.js";
import { getFirestore, collection, doc, getDoc, addDoc, setDoc, where, getDocs, query, getAggregateFromServer, sum, limit, orderBy, runTransaction } from "firebase/firestore";
import dayjs from "dayjs";

async function getInboxMessages(db, user, environment) {
    console.debug("🗄️ GETINBOXMESSAGES");
    var messages = [];
    const currentUserRef = doc(db, "user", user);
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "User does not exist!";
            }
            var messagesFromDb;
            if (u.data().messages) {
                messagesFromDb = u.data().messages[environment];
            }
            if (messagesFromDb) {
              for (var i=0; i<messagesFromDb.length; i++) {
                var msg = messagesFromDb[i];
                
                console.debug("🗄️ %o", msg);

                messages.push(msg);
              }
            } else {
              console.debug("🗄️ no messages found");
            }
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });

    return new Promise(function(resolve, reject) {
        resolve(messages);
    });
  }

  async function deleteInboxMessage(db, user, environment, msgId) {
    console.debug("🗄️ DELETEINBOXMESSAGE");

    const currentUserRef = doc(db, "user", user);
    
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldMessages = null;
            if (u.data().messages) {
              oldMessages = u.data().messages[environment];
            }
            var newMessages = [];
            
            if (oldMessages) {
              for (var i=0; i<oldMessages.length; i++) {
                console.debug("🗄️ ORIG: " + oldMessages[i]);
                if (msgId == oldMessages[i].id) {
                  console.log("🗄️ Message found. removing it from DB");
                  //newMessages.push(oldMessages[i]); 
                } else {
                  console.log("🗄️ Keeping message %d", oldMessages[i].id);
                  newMessages.push(oldMessages[i]);
                }
              }
            } 

            for (var i=0; i<newMessages.length; i++) {
              console.debug("🗄️ NEW: " + newMessages[i]);
            }

            var newUser = u.data();
            if (!newUser.messages) {
              newUser.messages = {};
            }
            if (!newUser.messages[environment]) {
              newUser.messages[environment] = [];
            }
            newUser.messages[environment] = newMessages;

            console.debug(newUser);

            transaction.update(currentUserRef, newUser);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

async function updateInboxMessage(db, user, environment, msgId, read) {
    console.debug("🗄️ UPDATEINBOXMESSAGE");

    const currentUserRef = doc(db, "user", user);
    
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldMessages = null;
            if (u.data().messages) {
              oldMessages = u.data().messages[environment];
            }
            var newMessages = [];
            
            if (oldMessages) {
              for (var i=0; i<oldMessages.length; i++) {
                console.debug("🗄️ ORIG: " + oldMessages[i]);
                if (msgId == oldMessages[i].id) {
                  console.log("🗄️ Message found. removing it from DB");
                  let curMsg = oldMessages[i];
                  curMsg.read = read
                  newMessages.push(oldMessages[i]); 
                } else {
                  console.log("🗄️ Keeping message %d", oldMessages[i].id);
                  newMessages.push(oldMessages[i]);
                }
              }
            } 

            for (var i=0; i<newMessages.length; i++) {
              console.debug("🗄️ NEW: " + newMessages[i]);
            }

            var newUser = u.data();
            if (!newUser.messages) {
              newUser.messages = {};
            }
            if (!newUser.messages[environment]) {
              newUser.messages[environment] = [];
            }
            newUser.messages[environment] = newMessages;

            console.debug(newUser);

            transaction.update(currentUserRef, newUser);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  async function addInboxMessage(db, user, environment, msg) {
    console.debug("🗄️ ADDINBOXMESSAGE");

    const currentUserRef = doc(db, "user", user);
    
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldMessages = null;
            if (u.data().messages) {
              oldMessages = u.data().messages[environment];
            } 
            var newMessages = [];
            var id = 0;
            if (oldMessages) {
              newMessages = oldMessages;
              for (var pos=0; pos<oldMessages.length; pos++) {
                if (oldMessages[pos].id > id) {
                    id = oldMessages[pos].id;
                }
              }
              msg.id = id + 1;
            } 
            newMessages.push(msg);

            for (var i=0; i<newMessages.length; i++) {
              console.debug("🗄️ NEW: " + newMessages[i]);
            }

            var newUser = u.data();
            if (!newUser.messages) {
              newUser.messages = {};
            }
            if (!newUser.messages[environment]) {
              newUser.messages[environment] = [];
            }
            newUser.messages[environment] = newMessages;

            console.debug(newUser);

            transaction.update(currentUserRef, newUser);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  export { getInboxMessages, deleteInboxMessage, updateInboxMessage, addInboxMessage }